import { render } from "./VolumeCards.vue?vue&type=template&id=e863363a&scoped=true"
import script from "./VolumeCards.vue?vue&type=script&lang=js"
export * from "./VolumeCards.vue?vue&type=script&lang=js"

import "./VolumeCards.vue?vue&type=style&index=0&id=e863363a&scoped=true&lang=css"

import exportComponent from "/var/www/bauminas/prod/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e863363a"]])

export default __exports__